import { useTranslation } from 'react-i18next';

import type { CustomerStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<CustomerStatus, string> = {
  guest: 'border-border text-muted-foreground',
  active: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  disabled: 'bg-destructive/10 text-destructive border-transparent',
};

export function CustomerStatusBadge({
  status,
  className,
}: {
  status: CustomerStatus;
  className?: string;
}) {
  const { t } = useTranslation('customers');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}
